export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/c5d6534f4f2cb925009575e748220704.svg";